import type { FeatureConfigMap } from '@luna/feature-config';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';
import { loans as base } from './base';
import { loans as AT } from './AT';
import { loans as CZ } from './CZ';
import { loans as HR } from './HR';
import { loans as HU } from './HU';
import { loans as RO } from './RO';
import { loans as RS } from './RS';
import { loans as SK } from './SK';

export const featureConfigMap: FeatureConfigMap<LoanFeatureConfig> = {
    base,
    AT: AT as LoanFeatureConfig,
    CZ: CZ as LoanFeatureConfig,
    HR: HR as LoanFeatureConfig,
    HU: HU as LoanFeatureConfig,
    RO: RO as LoanFeatureConfig,
    RS: RS as LoanFeatureConfig,
    SK: SK as LoanFeatureConfig,
};
